import { usePortalStore } from '../store/portal-store';
import type { UserIdentity } from '../types/user-identity';

/**
 * Read the current user identity from the portal store.
 *
 * @example
 * ```tsx
 * const { userIdentity, isReady } = useUserIdentity();
 * if (!isReady) return <Loader />;
 * ```
 */
export const useUserIdentity = (): { userIdentity: UserIdentity | null; isReady: boolean } => {
  const userIdentity = usePortalStore((s) => s.userIdentity);
  return { userIdentity, isReady: userIdentity !== null };
};
